import { createApiAction } from '@app/packages/api/utils'
import type { ApiPersonnelCheckOrder, ApiPersonnelCheckType } from '@app/packages/api/v2/types/entities'
import type { ApiPersonnelCheckOrderRequest } from '@app/packages/api/v2/types/params'

export const getPersonnelChecksTypes = () =>
  createApiAction('getPersonnelChecksTypes', dispatch =>
    dispatch<{ data: ApiPersonnelCheckType[] }>({ method: 'GET', endpoint: '/api/v2/personnel_checks/types' })
  )

export const postPersonnelChecksOrders = (request: ApiPersonnelCheckOrderRequest) =>
  createApiAction('postPersonnelChecksOrders', dispatch =>
    dispatch<{ data: ApiPersonnelCheckOrder }>({ method: 'POST', endpoint: '/api/v2/personnel_checks/orders', body: JSON.stringify(request) })
  )
